// extracted by mini-css-extract-plugin
export default {"manage-button":"M5hqC","manageButton":"M5hqC"};